import { Enums } from '../common/enums'

import { OpValidateInfoMessage } from './op-validate-info-message'

export class OpValidateInfo {

    // Properties

    private _referenceType: Enums.ReferenceType
    public get ReferenceType(): Enums.ReferenceType { return this._referenceType }

    private _referenceValue: any
    public get ReferenceValue(): any { return this._referenceValue }

    private _status: Enums.ValidationStatus
    public get Status(): Enums.ValidationStatus { return this._status }

    private _message: string[]
    public get Message(): string[] { return this._message }

    private _result: OpValidateInfoMessage[]
    public get Result(): OpValidateInfoMessage[] { return this._result }

    // Properties End


    // Ctor

    public constructor(opObj: any) {
        if (opObj != null) {
            this._referenceType = opObj.ReferenceType
            this._referenceValue = opObj.ReferenceValue
            this._status = opObj.Status
            this._message = opObj.Message

            if (opObj.Result != null) {
                this._result = opObj.Result.map((infoMessage: any) => new OpValidateInfoMessage(infoMessage))
            }
        }
    }

    // Ctor End
}